module.exports = __webpack_public_path__ + "assets/New_Ticket.0c14018e.svg";